import React, { createContext, useContext, useState, useEffect } from "react";
import * as api from "../api";

const AuthContext = createContext();

// Toutes les clés MarinaDZ à effacer lors du logout
const MARINA_KEYS = [
  "marinadz_token",
  "marinadz_user",
  "marinadz_users",
  "marinadz_annonces",
  "marinadz_conversations",
  "marinadz_rfq",
];

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Charger l'utilisateur au démarrage
  useEffect(() => {
    const token = localStorage.getItem("marinadz_token");
    if (token) {
      api.getMe()
        .then((res) => setUser(res.data))
        .catch(() => localStorage.removeItem("marinadz_token"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await api.login({ email, password });
    localStorage.setItem("marinadz_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    const res = await api.register(data);
    localStorage.setItem("marinadz_token", res.data.token);
    const me = await api.getMe();
    setUser(me.data);
    return me.data;
  };

  const googleLogin = async (data) => {
    const res = await api.googleLogin(data);
    localStorage.setItem("marinadz_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  // ✅ Logout corrigé : efface TOUTES les clés MarinaDZ
  const logout = () => {
    MARINA_KEYS.forEach(key => localStorage.removeItem(key));
    setUser(null);
  };

  const updateProfile = async (data) => {
    await api.updateProfile(data);
    const me = await api.getMe();
    setUser(me.data);
  };

  const upgradeToExposant = async (data) => {
    await api.upgradeExposant(data);
    const me = await api.getMe();
    setUser(me.data);
  };

  const refreshUser = async () => {
    try {
      const me = await api.getMe();
      setUser(me.data);
    } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      register,
      googleLogin,
      logout,
      updateProfile,
      upgradeToExposant,
      refreshUser,
      isAuthenticated: !!user,
      isAdmin:      user?.role === "admin",
      isExposant:   user?.role === "exposant",
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;